export const ALL_SUPPORTED_COUNTRIES = [
    'AD', // Andorra
    'AT', // Austria
    'BE', // Belgium
    'BG', // Bulgaria
    'CN', // China
    'CY', // Cyprus
    'HR', // Croatia
    'CZ', // Czech Republic
    'DK', // Denmark
    'EE', // Estonia
    'FI', // Finland
    'FR', // France
    'DE', // Germany
    'GG', // Guernsey
    'GR', // Greece
    'HK', // Hong Kong, China
    'HU', // Hungary
    'IC', // Canary Islands
    'IE', // Ireland
    'IL', // Israel
    'IS', // Iceland
    'IT', // Italy
    'JP', // Japan
    'LV', // Latvia
    'LI', // Liechtenstein
    'LT', // Lithuania
    'LU', // Luxembourg
    'MC', // Monaco
    'MO', // Macao
    'MT', // Malta
    'NL', // Netherlands
    'NO', // Norway
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SM', // San Marino
    'SG', // Singapore
    'SK', // Slovak Republic
    'SI', // Slovenia
    'ES', // Spain
    'SE', // Sweden
    'CH', // Switzerland
    'TW', // Taiwan
    'TR', // Turkey
    'GB', // United Kingdom
    'US', // United States
];
export const EU_MEMBERS = [
    'AT', // Austria
    'BE', // Belgium
    'BG', // Bulgaria
    'HR', // Croatia
    'CY', // Cyprus
    'CZ', // Czech Republic
    'DK', // Denmark
    'EE', // Estonia
    'FI', // Finland
    'FR', // France
    'DE', // Germany
    'GR', // Greece
    'HU', // Hungary
    'IE', // Ireland
    'IT', // Italy
    'LV', // Latvia
    'LT', // Lithuania
    'LU', // Luxembourg
    'MT', // Malta
    'NL', // Netherlands
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SK', // Slovak Republic
    'SI', // Slovenia
    'ES', // Spain
    'SE', // Sweden
];
export const ALL_COUNTRIES = [
    'AU', // Australia
    'AD', // Andorra
    'AF', // Afghanistan
    'AG', // Antigua and Barbuda
    'AL', // Albania
    'DZ', // Algeria
    'AM', // Armenia
    'AT', // Austria
    'AO', // Angola
    'AR', // Argentina
    'AS', // American Samoa
    'AW', // Aruba
    'AZ', // Azerbaijan
    'BA', // Bosnia and Herzegovina
    'BB', // Barbados
    'BD', // Bangladesh
    'BE', // Belgium
    'BF', // Burkina Faso
    'BG', // Bulgaria
    'BH', // Bahrain
    'BI', // Burundi
    'BJ', // Benin
    'BM', // Bermuda
    'BN', // Brunei Darussalam
    'BO', // Bolivia
    'BR', // Brazil
    'BS', // Bahamas, The
    'BT', // Bhutan
    'BW', // Botswana
    'BY', // Belarus
    'BZ', // Belize
    'KH', // Cambodia
    'CA', // Canada
    'CM', // Cameroon
    'KY', // Cayman Islands
    'CV', // Cape Verde
    'IC', // Canary Islands
    'CF', // Central African Republic
    'TD', // Chad
    'CN', // China
    'CL', // Chile
    'CD', // Congo, Dem. Rep.
    'CO', // Colombia
    'CR', // Costa Rica
    'KM', // Comoros
    'CG', // Congo, Rep.
    'CI', // Côte d'Ivoire
    'CU', // Cuba
    'CW', // Curaçao
    'HR', // Croatia
    'CY', // Cyprus
    'CZ', // Czech Republic
    'DK', // Denmark
    'DM', // Dominica
    'DJ', // Djibouti
    'DO', // Dominican Republic
    'EC', // Ecuador
    'SV', // El Salvador
    'EE', // Estonia
    'EG', // Egypt, Arab Rep.
    'ER', // Eritrea
    'ET', // Ethiopia
    'GQ', // Equatorial Guinea
    'FO', // Faeroe Islands
    'FJ', // Fiji
    'FI', // Finland
    'FR', // France
    'GF', // French Guiana
    'PF', // French Polynesia
    'GA', // Gabon
    'GD', // Grenada
    'GE', // Georgia
    'GI', // Gibraltar
    'GG', // Guernsey
    'GH', // Ghana
    'GL', // Greenland
    'GM', // Gambia, The
    'DE', // Germany
    'GN', // Guinea
    'GR', // Greece
    'GT', // Guatemala
    'GU', // Guam
    'GP', // Guadaloupe
    'GW', // Guinea-Bissau
    'GY', // Guyana
    'HK', // Hong Kong, China
    'HN', // Honduras
    'HT', // Haiti
    'HU', // Hungary
    'ID', // Indonesia
    'IE', // Ireland
    'IL', // Israel
    'IM', // Isle of Man
    'IN', // India
    'IQ', // Iraq
    'IR', // Iran, Islamic Rep.
    'IS', // Iceland
    'IT', // Italy
    'JO', // Jordan
    'JP', // Japan
    'JM', // Jamaica
    'KE', // Kenya
    'KG', // Kyrgyz Republic
    'KI', // Kiribati
    'KP', // North Korea
    'KR', // South Korea
    'KW', // Kuwait
    'KZ', // Kazakhstan
    'XK', // Kosovo
    'LA', // Lao PDR
    'LB', // Lebanon
    'LV', // Latvia
    'LI', // Liechtenstein
    'LS', // Lesotho
    'LR', // Liberia
    'LT', // Lithuania
    'LU', // Luxembourg
    'LY', // Libya
    'YT', // Mayotte
    'MA', // Morocco
    'MC', // Monaco
    'MD', // Moldova
    'ME', // Montenegro
    'MG', // Madagascar
    'MH', // Marshall Islands
    'MK', // Macedonia, FYR
    'ML', // Mali
    'MM', // Myanmar
    'MN', // Mongolia
    'MO', // Macao
    'MP', // Northern Mariana Islands
    'MQ', // Martinique
    'MR', // Mauritania
    'MT', // Malta
    'MU', // Mauritius
    'MV', // Maldives
    'MW', // Malawi
    'MX', // Mexico
    'MY', // Malaysia
    'FM', // Micronesia, Fed. Sts.
    'MZ', // Mozambique
    'NA', // Namibia
    'NE', // Niger
    'NG', // Nigeria
    'NI', // Nicaragua
    'NL', // Netherlands
    'AN', // Netherlands Antilles
    'NF', // Norfolk Island
    'NO', // Norway
    'NP', // Nepal
    'NC', // New Caledonia
    'NZ', // New Zealand
    'OM', // Oman
    'PA', // Panama
    'PG', // Papua New Guinea
    'PK', // Pakistan
    'PW', // Palau
    'PY', // Paraguay
    'PE', // Peru
    'PH', // Philippines
    'PL', // Poland
    'PT', // Portugal
    'PR', // Puerto Rico
    'QA', // Qatar
    'RE', // Reunion islands
    'RO', // Romania
    'RU', // Russia
    'RW', // Rwanda
    'WS', // Samoa
    'SM', // San Marino
    'SA', // Saudi Arabia
    'SC', // Seychelles
    'SL', // Sierra Leone
    'RS', // Serbia
    'SN', // Senegal
    'SG', // Singapore
    'SX', // Sint Maarten
    'SK', // Slovak Republic
    'SI', // Slovenia
    'SD', // Sudan
    'SR', // Suriname
    'SO', // Somalia
    'SB', // Solomon Islands
    'ES', // Spain
    'SZ', // Swaziland
    'SE', // Sweden
    'CH', // Switzerland
    'LC', // St. Lucia
    'KN', // St. Kitts and Nevis
    'VC', // St. Vincent and the Grenadines
    'LK', // Sri Lanka
    'ZA', // South Africa
    'SY', // Syrian Arab Republic
    'ST', // São Tomé and Principe
    'TW', // Taiwan
    'TJ', // Tajikistan
    'TZ', // Tanzania
    'TH', // Thailand
    'TL', // Timor-Leste
    'TM', // Turkmenistan
    'TG', // Togo
    'TO', // Tonga
    'TT', // Trinidad and Tobago
    'TN', // Tunisia
    'TR', // Turkey
    'VI', // Virgin Islands (U.S.)
    'VE', // Venezuela, RB
    'VN', // Vietnam
    'VU', // Vanuatu
    'UA', // Ukraine
    'UG', // Uganda
    'AE', // United Arab Emirates
    'GB', // United Kingdom
    'US', // United States
    'UY', // Uruguay
    'UZ', // Uzbekistan
    'YE', // Yemen, Rep.
    'ZM', // Zambia
    'ZW', // Zimbabwe
];
/**
 * @param code
 */
export const isEuMember = (code) => EU_MEMBERS.some((euCountry) => euCountry === code.toUpperCase());
